/* Detail Shop Media: package + video mix picker.
   Saves the mix on the cart line as properties, e.g. "Paint Protection Film: 3",
   "Exterior Detailing (Mobile): 1". The mix is optional: if it is skipped or incomplete, a "Video mix" property tells us to collect it on the onboarding form. */
(function () {
  function init(root) {
    var form = root.querySelector('[data-dsm-form]') || root.querySelector('form');
    if (!form || form.dataset.dsmReady) return;
    form.dataset.dsmReady = '1';

    var variants = Array.prototype.slice.call(form.querySelectorAll('input[name="id"]'));
    var rows = Array.prototype.slice.call(form.querySelectorAll('[data-service]'));
    var submits = Array.prototype.slice.call(form.querySelectorAll('[data-submit]'));
    var errorEl = form.querySelector('[data-error]');
    var skipEl = form.querySelector('[data-mix-skip]');
    var counts = rows.map(function () { return 0; });

    function q(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function selected() { return variants.filter(function (v) { return v.checked; })[0] || variants[0]; }
    function total() { var v = selected(); return v ? parseInt(v.dataset.videos, 10) || 0 : 0; }
    function assigned() { return counts.reduce(function (a, b) { return a + b; }, 0); }

    function location(row) {
      var r = row.querySelector('.dsm-toggle input:checked');
      return r ? r.value : null;
    }

    function render() {
      var t = total(), a = assigned(), left = t - a;
      var v = selected();
      q('[data-total], [data-total-label]').forEach(function (el) { el.textContent = t; });
      q('[data-assigned]').forEach(function (el) { el.textContent = a; });
      q('[data-price-display]').forEach(function (el) { if (v) el.textContent = v.dataset.price; });
      q('[data-per-video]').forEach(function (el) { el.textContent = v ? v.dataset.per : ''; });
      var status = root.querySelector('[data-status]');
      if (status) {
        status.textContent = left === 0 ? 'Ready' : (a === 0 ? 'Optional' : left + ' left, or finish on the form');
        status.dataset.ready = left === 0 ? 'true' : 'false';
      }
      var bar = root.querySelector('[data-bar]');
      if (bar) bar.style.width = (t ? Math.min(100, Math.round(a / t * 100)) : 0) + '%';

      rows.forEach(function (row, i) {
        var c = counts[i];
        row.querySelector('[data-count]').textContent = c;
        row.querySelector('[data-step="-1"]').disabled = c === 0;
        row.querySelector('[data-step="1"]').disabled = left <= 0;
        row.dataset.active = c > 0 ? 'true' : 'false';
        var prop = row.querySelector('[data-prop]');
        var name = row.dataset.service;
        var loc = location(row);
        if (loc) name += ' (' + loc + ')';
        prop.name = 'properties[' + name + ']';
        prop.value = String(c);
        prop.disabled = c === 0;
      });

      submits.forEach(function (b) { b.removeAttribute('aria-disabled'); b.disabled = false; });
      if (skipEl) {
        if (left === 0) { skipEl.disabled = true; }
        else {
          skipEl.disabled = false;
          skipEl.value = a === 0 ? 'Choose on onboarding form' : a + ' of ' + t + ' chosen, rest on onboarding form';
        }
      }
      if (errorEl) errorEl.hidden = true;
    }

    rows.forEach(function (row, i) {
      row.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-step]');
        if (!btn || btn.disabled) return;
        var step = parseInt(btn.dataset.step, 10);
        var next = counts[i] + step;
        if (next < 0 || (step > 0 && assigned() >= total())) return;
        counts[i] = next;
        render();
      });
      row.addEventListener('change', render);
    });

    variants.forEach(function (v) {
      v.addEventListener('change', function () {
        if (assigned() > total()) counts = counts.map(function () { return 0; });
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.value);
          window.history.replaceState({}, '', url.toString());
        } catch (err) {}
        render();
      });
    });

    form.addEventListener('submit', function () { render(); });

    // Gallery thumbnails
    q('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var n = btn.dataset.thumb;
        q('[data-media]').forEach(function (m) {
          var on = m.dataset.media === n;
          m.style.display = on ? 'flex' : 'none';
          if (!on) { var vid = m.querySelector('video'); if (vid) vid.pause(); }
        });
        q('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
      });
    });

    render();
  }

  function boot() { document.querySelectorAll('[data-dsm-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
